export const prettifyFileName = (filename: string) => {
    const idIndex = filename.lastIndexOf('_');
    return filename.slice(0, idIndex);
}